import { useState } from 'react';

import { sleep } from 'util/helper';

export const useAccordion = ({ disabled }) => {
	const [{ dropdown, visible }, setState] = useState({
		dropdown: disabled,
		visible: disabled,
	});

	const onToggle = async () => {
		if (disabled) {
			return;
		}

		setState({ dropdown: !dropdown, visible });

		if (dropdown) {
			setState({ dropdown: !dropdown, visible: false });
		} else {
			await sleep(300);
			setState({ dropdown: !dropdown, visible: true });
		}
	};

	return [{ dropdown, visible }, onToggle];
};
